'use strict';

var _require = require('./baseProperties'),
    baseProperties = _require.baseProperties;

module.exports.OrgaIdentSchema = {
  title: 'OrgaIdent',
  type: 'object',
  properties: Object.assign({}, baseProperties)
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/schema/orgaIdent.js
// module id = 6Lti
// module chunks = 0